/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { all, takeLatest } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';
import { Song } from '../../../services/playlist';
import { fetchWrapperFuncNoLoading } from '../../../utils';
import { getPlaylistAdminApi } from '../../System/systemConfig';
import { setSong, songSetAlbums, SONG_LOAD, SONG_LOAD_ALBUMS, SONG_SAVE } from './actions';

const playlistApi = getPlaylistAdminApi();

function* loadSongGenerator(action: Action<string>) {
    let songId = action.payload;
    yield* fetchWrapperFuncNoLoading(() => playlistApi.getSong(songId), [r => setSong(r)]);
}

function* loadAlbums(action: Action<string>) {
    let songId = action.payload;
    yield* fetchWrapperFuncNoLoading(() => playlistApi.getAlbumsBySong(songId), [r => songSetAlbums(r)]);
}

function* saveSongGenerator(action: Action<Song>) {
    let song = action.payload;
    yield* fetchWrapperFuncNoLoading(() => playlistApi.updateSong(song), [r => setSong(r)]);
}

function* watchForSongEditActions() {
    yield takeLatest(SONG_LOAD, loadSongGenerator);
    yield takeLatest(SONG_SAVE, saveSongGenerator);
    yield takeLatest(SONG_LOAD_ALBUMS, loadAlbums);
}

export function* songEditSagas() {
    yield all([watchForSongEditActions()]);
}
